import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Boondock, Listing } from '@curbnturf/entities';
import { UserImageComponent } from '@curbnturf/image-processing/src/lib/user-image/user-image.component';

@Component({
  selector: 'curbnturf-listing-title',
  templateUrl: './listing-title.component.html',
  styleUrls: ['./listing-title.component.scss'],
  standalone: true,
  imports: [NgIf, UserImageComponent],
})
export class ListingTitleComponent {
  @Input() listing: Listing | Boondock;
}
